import type { Facet } from '../../Search/Facet.csharp';
import type { ConversionFunction } from '../PagedFetchData/SearchCriteriaUtils';
import { replaceNotFriendlyCharacters } from '../Utils/utils';
import { TwoWayMapping } from './TwoWayMapping';

export class FacetsQueryParameterConverter {
    private readonly facets: Facet[];

    private readonly queryParameterNamesAndTranslationsTwoWayMapping: TwoWayMapping;

    constructor(facets: Facet[]) {
        this.facets = facets;
        const parameterNamesToTranslationsMapping = facets.reduce((accumulator: Record<string, string>, facet) => {
            accumulator[facet.id] = replaceNotFriendlyCharacters(facet.label.toLowerCase());

            return accumulator;
        }, {});
        this.queryParameterNamesAndTranslationsTwoWayMapping = new TwoWayMapping(parameterNamesToTranslationsMapping);
    }

    public convertFromUserReadableQueryParameter: ConversionFunction = item => {
        const name = this.queryParameterNamesAndTranslationsTwoWayMapping.findReverse(item.name) || item.name;
        const value = item.value.split('-').pop() || item.value;

        return { name, value };
    };

    public convertToUserReadableQueryParameter: ConversionFunction = item => {
        const name = this.queryParameterNamesAndTranslationsTwoWayMapping.find(item.name) || item.name;
        const valueLabel = this.findLabelForQueryParameterValue(item.value, item.name);
        const value = valueLabel ? `${replaceNotFriendlyCharacters(valueLabel)}-${item.value}` : item.value;

        return { name, value };
    };

    private findLabelForQueryParameterValue(value: string, facetId: string) {
        if (isNaN(Number(value))) {
            return undefined;
        }

        const facet = this.findFacetOptionWithMatchingId(this.facets, facetId, value);

        return facet ? facet.label : undefined;
    }

    private findFacetOptionWithMatchingId(facets: Facet[], facetId: string, expectedId: string) {
        const facet = facets.find(f => f.id === facetId);

        return facet && facet.options.find(option => option.id === expectedId);
    }
}
